import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    subItem: {
        paddingTop: 10,
    },
    leftColumn: {
        paddingRight: 30,
    },
    rightColumn: {
        paddingLeft: 30,
    },
    title: {
        paddingRight: 10
    },
}));

const FormRowItemContent = ({
    leftChildren,
    rightChildren,
    isSigleRow,
    sigleRowTitleXs,
    titleItemXs,
    rowAlignItems,
    maxWidthXs,
}) => {
    const classes = useStyles();

    const labelMaxWidths = {
        1: { maxWidth: '12.22%', flexBasis: '12.22%'}
    };
    const valueMaxWidths = {
        1: { maxWidth: '87.78%', flexBasis: '87.78%'},
    };
    const labelStyle = labelMaxWidths[maxWidthXs] ?? {};
    const valueStyle = valueMaxWidths[maxWidthXs] ?? {};

    return (
        <Grid container item xs={12} justify="space-between" className={classes.subItem}>
            {
                isSigleRow ? <Grid container item xs={12} className={classes.leftColumn}>
                    {
                        leftChildren?.renderCell ?? <Grid container alignItems={rowAlignItems ?? 'center'}>
                            <Grid
                                container
                                item
                                xs={sigleRowTitleXs ?? 1}
                                className={classes.title}
                                style={labelStyle}
                            >
                                {leftChildren?.title}
                            </Grid>
                            <Grid
                                container
                                item
                                xs={sigleRowTitleXs ? (12 - sigleRowTitleXs) : 11}
                                style={valueStyle}
                            >
                                {leftChildren?.value}
                            </Grid>
                        </Grid>
                    }
                </Grid> :
                <>
                    <Grid container item xs={isSigleRow ? 12 : 6} className={classes.leftColumn}>
                        {
                            leftChildren?.renderCell ?? <Grid container alignItems={rowAlignItems ?? 'center'}>
                                    <Grid container item xs={titleItemXs ?? 3} className={classes.title}>{leftChildren?.title}</Grid>
                                    <Grid container item xs={titleItemXs ? (12 - titleItemXs) : 9}>{leftChildren?.value}</Grid>
                            </Grid>
                        }
                    </Grid>
                    <Grid container item xs={6} className={classes.rightColumn}>
                        {
                            rightChildren?.renderCell ?? <Grid container alignItems={rowAlignItems ?? 'center'}>
                                    <Grid container item xs={titleItemXs ?? 3} className={classes.title}>{rightChildren?.title}</Grid>
                                    <Grid container item xs={titleItemXs ? (12 - titleItemXs) : 9}>{rightChildren?.value}</Grid>
                            </Grid>
                        }
                    </Grid>
                </>
            }
        </Grid>
    );
};

export default FormRowItemContent;
